import { render, staticRenderFns } from "./DetGuiasFluvialForm.vue?vue&type=template&id=d8f23d6c&scoped=true"
import script from "./DetGuiasFluvialForm.vue?vue&type=script&lang=js"
export * from "./DetGuiasFluvialForm.vue?vue&type=script&lang=js"
import style0 from "./DetGuiasFluvialForm.vue?vue&type=style&index=0&id=d8f23d6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8f23d6c",
  null
  
)

export default component.exports